<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="6">
          <b-form-group
              description="Choose from our selection of backgrounds."
          >
            <drop-down-field
                field-name="Theme Background Selection:"
                field-key="theme_bg"
                :options-json="optionsJSON"
                :selected-value="settingsUser.bgTheme"
                select-word="Theme"
                @selected-option="handleOptionsSelect"
            />
          </b-form-group>
          <b-form-group>
            <drop-down-field
                field-name="Display the Cover Your Way:"
                field-key="cover_display"
                :options-json="optionsJSON"
                :selected-value="settingsUser.coverDisplay"
                select-word="Display"
                @selected-option="handleOptionsSelect"
            />
          </b-form-group>
          <b-form-group>
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <label>Song Library:</label>
          <b-form-group description="Choose from our selection of songs">
            <b-row>
              <b-col cols="1">
                <b-icon
                  icon="music-note-list"
                  animation="fade"
                  font-scale="2"
                />
              </b-col>
              <b-col>
                <item-store
                  :modal-id="modalSongStoreId"
                  store-title="Song Library"
                  btn-download-title="Add To Your List"
                  name="title"
                  asset-url-path="/assets/apps/playlist/"
                  :store-items="storeAudioItems"
                  :user-owned-items="userDataPlaylist"
                  @selected-items="handleSelectedAudios"
                />
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group
            :description="
              `Click menu to see your current ${userDataPlaylist.length} songs`
            "
          >
            <items-sidebar-settings
              :items="userDataPlaylist"
              :assets-url-home="assetsURLHome"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DropDownField from "@/components/blockResources/_components/dropDownField";
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import themesJSON from "../../assets/json/themes.json";
import optionsJSON from "../../assets/json/optionsJSON.json";
import ItemStore from "@/components/blockResources/_components/itemStore";
import ItemsSidebarSettings from "@/components/blockResources/_components/itemsSideBar";
import storeItemsAudioJSON from "../../assets/json/storeItemsSongs.json";
import DefaultPlayList from "@/components/blockResources/resourcePlayList/assets/json/defaultPlayList.json";
export default {
  name: "Settings_PlayList",
  components: {
    ItemStore,
    ItemsSidebarSettings,
    DropDownField
  },
  mixins: [ResourceBlockSettings],
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData"
    }),
    storeAudioItems() {
      return Array.isArray(storeItemsAudioJSON) ? storeItemsAudioJSON : [];
    },
    searchedResources() {
      if (this.searchStr.trim() == "") return this.allResources;

      return this.allResources.filter(tool => {
        return tool.name
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
      });
    },
    /* DATA */
    userDataPlaylist() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].playlist
        ? this.userData[`app_${this.resource.toolId}`].playlist
        : DefaultPlayList;
    }
  },
  methods: {
    handleSelectedAudios(audios) {
      console.log(`These audios selected:${audios}`);
      let playListAudios = {
        playlist: audios
      };

      let notif = {
        //create message
        title: `${audios.length} Songs Added`,
        description: "Congrats you have updated your family playlist",
        variant: "success"
      };
      const payload = {
        userData: playListAudios,
        notif: notif,
        key: "playlist"
      };

      this.handleUpdateUserData(payload);
    },
    handleOptionsSelect({key, option}){
      debugger;
      switch (key){
        case 'bg_theme':
          this.settingsUser.bgTheme = option.value ? option.value : null;
          break;
        case 'cover_display':
          this.settingsUser.coverDisplay = option.value ? option.value : null;
          break;
        default:
          //applog bug
          break;
      }
      this.handleSettingsUserChange();
    }
  },
  data() {
    return {
      toolTips: {
        bgTheme:
          "Background is not avail when app's Activity or app's Settings is on. " +
          "Turn off Activity and Settings in Settings > Settings > Display Settings",
        coverDisplay:
          "Background is not avail when app's Activity or app's Settings is on. " +
          "Turn off Activity and Settings in Settings > Settings > Display Settings"
      },
      settingsUser: {
        gridSize:
          this.settings && this.settings.user && this.settings.user.gridSize
            ? this.settings.user.gridSize
            : 2,
        bgTheme:
          this.settings && this.settings.user && this.settings.user.bgTheme
            ? this.settings.user.bgTheme
            : "church",
        coverDisplay:
          this.settings && this.settings.user && this.settings.user.coverDisplay
            ? this.settings.user.coverDisplay
            : "full",
        _isRepeat:
          this.settings &&
          this.settings.user &&
          this.settings.user._isRepeat !== undefined
            ? this.settings.user._isRepeat
            : true,
        _isShuffle:
          this.settings &&
          this.settings.user &&
          this.settings.user._isShuffle !== undefined
            ? this.settings.user._isShuffle
            : false,
        _showSelectedBys:
          this.settings &&
          this.settings.user &&
          this.settings.user._showSelectedBys !== undefined
            ? this.settings.user._showSelectedBys
            : false
      },
      themesJSON,
      optionsJSON,
      storeItemsAudioJSON,
      assetsURLHome: "/assets/apps/playlist/",
      sidebarId: "settings-sidebar",
      modalSongStoreId: "song-store",
      toggles: [
        {
          name: "Repeat",
          description:
            "Activate repeat mode to loop your favorite tracks and keep the music playing endlessly.",
          property: "_isRepeat",
          type: "btns",
          text: "Repeat",
          isAvail: true,
          value: false
        },
        {
          name: "Shuffle",
          description:
            "Enable shuffle mode to mix up your music library for a surprising listening experience",
          property: "_isShuffle",
          type: "btns",
          text: "Shuffle",
          isAvail: true,
          value: true
        },
        {
          name: "Selected by Family",
          description: "Enable to display the family me who selected this song",
          property: "_showSelectedBys",
          type: "btns",
          text: "Show selected by family",
          isAvail: true,
          value: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
